import { FC } from 'react';
import { Box, useTheme } from '@chakra-ui/react';

const TableCellTextModalContent: FC<{ fullText: string | undefined }> = ({
  fullText
}) => {
  const theme = useTheme();

  return (
    <Box
      fontFamily={theme.fonts.regular}
      fontSize='12px'
      lineHeight='16px'
      color={theme.colors.mediumGrey}
    >
      {fullText}
    </Box>
  );
};

export default TableCellTextModalContent;
